import React from "react";
import FullLoadBooking from "../../components/service-pages/full-load-booking/FullLoadBooking";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";
import { FaqsResponse } from "@vahak/core/dist/_services/faq.service";
import {
    getFullTruckBookingPageLayout,
    getFullTruckBookingStaticProps
} from "../../components/service-pages/constants/full-truck-booking-methods";

export default function FullTruckLoadPage({ faqs }: { faqs: FaqsResponse[] }) {
    return <FullLoadBooking faqs={faqs} />;
}

FullTruckLoadPage.getLayout = getFullTruckBookingPageLayout;

export async function getStaticProps({ locale }: any) {
    return {
        props: {
            isMobile: false,
            ...(await getFullTruckBookingStaticProps()),
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("servicePages")))
        }
    };
}
